import { CircleDot, Gift, Instagram, Link2, Mail, MapPin, MessageCircle, Phone, type LucideIcon } from 'lucide-react';
import type { FabButtonType } from '@/shared/types/fab-button';

interface FabTypeMeta {
  label: string;
  icon: LucideIcon;
  placeholder: string;
  valueLabel: string;
}

export const FAB_TYPE_META: Record<FabButtonType, FabTypeMeta> = {
  link: { label: 'Link', icon: Link2, placeholder: 'https://…', valueLabel: 'URL' },
  whatsapp: { label: 'WhatsApp', icon: MessageCircle, placeholder: '(11) 99999-9999', valueLabel: 'Telefone' },
  phone: { label: 'Telefone', icon: Phone, placeholder: '(11) 3333-3333', valueLabel: 'Telefone' },
  instagram: { label: 'Instagram', icon: Instagram, placeholder: '@usuario', valueLabel: 'Perfil' },
  email: { label: 'E-mail', icon: Mail, placeholder: 'contato@loja.com', valueLabel: 'E-mail' },
  location: { label: 'Localização', icon: MapPin, placeholder: 'https://maps.google…', valueLabel: 'Link do mapa' },
  other: { label: 'Outro', icon: CircleDot, placeholder: 'https://… ou ação personalizada', valueLabel: 'Destino' },
  mgm: { label: 'Indique e ganhe', icon: Gift, placeholder: '', valueLabel: 'Link (gerado automaticamente)' },
};

export const FAB_TYPES = Object.keys(FAB_TYPE_META) as FabButtonType[];

/**
 * Tipos que o seletor oferece. "Indique e ganhe" só aparece com o módulo MGM
 * ligado no passbook e quando ainda não existe outro botão desse tipo.
 */
export function selectableFabTypes(allowMgm: boolean): FabButtonType[] {
  return FAB_TYPES.filter((t) => t !== 'mgm' || allowMgm);
}
